/**
 * Gemini AI utilities
 * Note: All AI operations are now handled by Cloud Functions for security
 */

import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

const improveEntryWritingCallable = httpsCallable(functions, 'improveEntryWriting');

export const improveWriting = async (text) => {
  try {
    const result = await improveEntryWritingCallable({ text });
    return result.data.improvedText;
  } catch (error) {
    console.error('Error improving writing:', error);
    throw new Error('Failed to improve writing. Please try again.');
  }
};
